"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersistDirectToVizzlyApi = exports.PersistViaQueryEngine = exports.ImplementationStrategy = void 0;
class ImplementationStrategy {
}
exports.ImplementationStrategy = ImplementationStrategy;
class PersistViaQueryEngine extends ImplementationStrategy {
    shouldPersistViaQueryEngine() {
        return true;
    }
}
exports.PersistViaQueryEngine = PersistViaQueryEngine;
class PersistDirectToVizzlyApi extends ImplementationStrategy {
    shouldPersistViaQueryEngine() {
        return false;
    }
}
exports.PersistDirectToVizzlyApi = PersistDirectToVizzlyApi;
